import { Link } from 'react-router-dom';
import { GraduationCap, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-cabernet text-cream/90 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <GraduationCap className="w-6 h-6 text-brass" />
              <span className="font-heading text-xl font-semibold text-cream">
                GoodLiving Scholars
              </span>
            </div>
            <p className="font-body text-sm text-cream/70 leading-relaxed">
              A 501(c)(3) non-profit empowering the next generation of entrepreneurs
              through scholarships, mentorship, and global exposure.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading text-lg font-medium text-brass mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/scholarships" className="block text-sm font-body text-cream/70 hover:text-brass transition-colors">
                Scholarships
              </Link>
              <Link to="/mentorship" className="block text-sm font-body text-cream/70 hover:text-brass transition-colors">
                Mentorship Program
              </Link>
              <Link to="/donate" className="block text-sm font-body text-cream/70 hover:text-brass transition-colors">
                Support Our Mission
              </Link>
              <Link to="/about" className="block text-sm font-body text-cream/70 hover:text-brass transition-colors">
                About Us
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-medium text-brass mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm text-cream/70">
                <Mail className="w-4 h-4 text-brass" />
                <span className="font-body">Scholars@goodlivingllc.info</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-cream/70">
                <MapPin className="w-4 h-4 text-brass" />
                <span className="font-body">United States</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cream/10 text-center">
          <p className="text-xs font-accent text-cream/50">
            &copy; {new Date().getFullYear()} GoodLiving Scholars Incorporated. All rights reserved. 501(c)(3) Non-Profit Organization. EIN: 93-1729927
          </p>
        </div>
      </div>
    </footer>
  );
}
